import { render } from "./LoginFormBootstrap.vue?vue&type=template&id=4525067e&scoped=true"
import script from "./LoginFormBootstrap.vue?vue&type=script&lang=js"
export * from "./LoginFormBootstrap.vue?vue&type=script&lang=js"

import "./LoginFormBootstrap.vue?vue&type=style&index=0&id=4525067e&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\WebDashBoard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4525067e"]])

export default __exports__